export default {"src":"/_next/static/media/workflow.b8210a5f.svg","height":2500,"width":3415,"blurWidth":0,"blurHeight":0};